// extracted by mini-css-extract-plugin
export default {"sidebar":"sidebar_sidebar__g65-n","lg":"sidebar_lg__4B+up","outer":"sidebar_outer__d8tWq","inner":"sidebar_inner__ivUG0"};